import React, { useEffect } from 'react'
import { highlightBugReportButton, unhighlightBugReportButton } from "../../BugReport/BugReportButton/BugRepportButtonUtil";
import { Modal } from 'antd'
import classes from './Modal.module.css';

const CustomModal = ({
    show,
    onHide,
    header,
    footer,
    footerElement,
    data,
    children,
    size
}) => {
    const maxModalWidth = {
        sm: 540,
        md: 720,
        lg: 960,
        xl: 1140
    };

    const bodyStyle = {
        padding: 0
    };

    useEffect(() => {
        if (show) {
            highlightBugReportButton();
        } else {
            unhighlightBugReportButton();
        }
    }, [show]);

    return (
        <Modal
            className={classes.modal}
            visible={show}
            onCancel={onHide}
            title={(
                <div className={classes.modalTitle}>
                    {header}
                </div>
            )}
            footer={footer ? footerElement : null}
            width={maxModalWidth[size] ?? (typeof size === 'number' ? size : maxModalWidth.lg)}
            centered
            bodyStyle={bodyStyle}
        >
            {(!data) && children}
        </Modal>
    );
}

export default CustomModal
